<script>
    import {elementDetails} from '../workspacesStore.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import MediaColumn from '../../DataGrid/ColumnRenderers/MediaColumn.svelte';
    import {sgettext} from '../../../i18n.js';

    export let rows = $elementDetails ? $elementDetails.tools : [];

    let columns = {
        element_slide: {
            label: sgettext('$$IMAGE$$'),
            renderer: MediaColumn,
            width: '160px'
        },
        tool_description: {
            label: sgettext('$$TOOL$$')
        },
        quantity: {
            label: sgettext('$$QUANTITY$$'),
            width: '100px'
        },
        specification: {
            label: sgettext('$$SPECIFICATION$$')
        }
    }
</script>


<DataTable
    small={false}
    {columns}
    {rows}
/>
